import { useCallback } from "react";

import { getClient } from "services";
import useArePushNotificationsSupported from "services/firebase/messaging/hooks/useArePushNotificationsSupported";
import useGetMessaging from "services/firebase/messaging/hooks/useGetMessaging";
import {
  getMessagingToken,
  getPushSubscription,
  getServiceWorkerRegistration,
  hasNotificationsPermissions
} from "services/firebase/messaging/utils";
import getPushType from "services/firebase/messaging/utils/getPushType";

import logError from "seneca-common/utils/sentry/logError";

export default function useResubscribeToPushNotifications() {
  const pushNotificationsAreSupported = useArePushNotificationsSupported();
  const messaging = useGetMessaging();

  const resubscribeToPushNotifications = useCallback(async () => {
    try {
      if (pushNotificationsAreSupported) {
        const client = getClient("notificationsService");

        const registration = await getServiceWorkerRegistration();
        const hasPermission = await hasNotificationsPermissions();
        const subscription = await getPushSubscription({ registration });

        if (messaging && hasPermission && !subscription) {
          const token = await getMessagingToken({ registration, messaging });

          if (token) {
            const type = getPushType();
            await client.savePushNotificationsToken({ type, token });
          }
        }
      }
    } catch (error) {
      logError(error, {
        message: "Push notifications: resubscribe to push notifications error."
      });
    }
  }, [pushNotificationsAreSupported, messaging]);

  return { resubscribeToPushNotifications };
}
